import { SyntheticEvent } from 'react'

import Videocam from '@mui/icons-material/Videocam'
import { alpha, lighten, Stack, Tab, Tabs } from '@mui/material'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { PLATFORM, STREAMS_PLATFORM_ENABLED } from '@/constants/platform'
import { Platform } from '@/types/platform'

import { DataCastIcon } from '../Icons'
import { LoginForgotPassActiveForm, useCredentials } from './useLogin/useCredentials'
import { ForgotPasswordForm } from './ForgotPasswordForm'
import { LoginForm } from './LoginForm'

type AvailableTabs = Platform

export const LoginContainer = () => {
  const theme = useTheme()
  const { platform, onPlatformUpdate, form } = useCredentials()

  const onTabChange = (_event: SyntheticEvent, value: AvailableTabs) => {
    onPlatformUpdate(value)
  }

  return (
    <Stack alignItems={'center'} justifyContent={'center'} sx={{ width: '50%' }}>
      <Box sx={{ width: '50%' }}>
        <Box>
          <Typography variant={'h3'} fontWeight={'bold'}>
            {form === LoginForgotPassActiveForm.LOGIN && 'Sign In'}
            {form === LoginForgotPassActiveForm.FORGOT_PASSWORD && 'Forgot password'}
          </Typography>
          <Typography
            variant={'body1'}
            sx={{ mt: 1, color: lighten(theme.palette.textColour, 0.3) }}
          >
            {form === LoginForgotPassActiveForm.LOGIN &&
              'Enter your credentials to access your account.'}
            {form === LoginForgotPassActiveForm.FORGOT_PASSWORD &&
              'Enter your email to receive reset message.'}
          </Typography>
        </Box>
        <Tabs onChange={onTabChange} value={platform} sx={{ mt: 3 }}>
          <Tab
            value={PLATFORM.DDE}
            label={'Data Platform'}
            icon={<DataCastIcon />}
            iconPosition={'start'}
            sx={{ width: STREAMS_PLATFORM_ENABLED ? '50%' : '100%' }}
          />
          {STREAMS_PLATFORM_ENABLED && (
            <Tab
              value={PLATFORM.DGE}
              label={'Streams Platform'}
              icon={<Videocam />}
              iconPosition={'start'}
              sx={{ width: '50%' }}
            />
          )}
        </Tabs>
        <Box
          sx={{
            px: 2,
            py: 5,
            borderRadius: '0 0 6px 6px',
            backgroundColor: alpha('#000', 0.02)
          }}
        >
          {form === LoginForgotPassActiveForm.LOGIN && <LoginForm />}
          {form === LoginForgotPassActiveForm.FORGOT_PASSWORD && <ForgotPasswordForm />}
        </Box>
      </Box>
    </Stack>
  )
}
